import React from "react";
import Header from "./Header";
import { Switch, Route } from "react-router-dom";
import App from "../../Screens/App";
import Builds from "../../Screens/Builds";
import ServiceList from "../../Screens/ServiceList";
import ServiceDetail from "../../Screens/ServiceDetail";
import ConfigurationCheck from "../../Screens/ConfigurationCheck";
import Broker from "../../Screens/Broker";
import Select from "../../Screens/Select";

export default function Layout() {
  return (
    <div className="app">
      <Header />

      <Switch>
        <Route path="/:lang/build/:slug/:number" exact component={App} />
        <Route path="/:lang/build/:slug" exact component={App} />
        <Route path="/:lang/builds" exact component={Builds} />
        <Route path="/:lang/service" exact component={ServiceList} />
        <Route path="/:lang/service/:id" exact component={ServiceDetail} />
        <Route
          path="/:lang/configuration/:id"
          exact
          component={ConfigurationCheck}
        />
        <Route path="/:lang/account" exact component={Broker} />
        <Route path="/:lang" exact component={Select} />
        <Route path="/" exact component={Select} />
      </Switch>
    </div>
  );
}
